type Reading2Payload = {
    value?: any;
    ts?: any;
};

const normalizeReading2Payload = (payload: any): Reading2Payload | null => {
    if (!payload) return null;
    if (Array.isArray(payload)) return payload[0] ?? null;
    return payload;
};

const getValueAtSaid = (value: any, said: number): any => {
    if (Array.isArray(value)) {
        return value[said] ?? null;
    }
    if (value && typeof value === "object") {
        if (value[said] !== undefined) return value[said];
    }
    return null;
};

export const getControllerStatusFromReading2 = (
    payload: any,
    said: number
): { status: any; timestamp: any } | null => {
    const normalized = normalizeReading2Payload(payload);
    if (!normalized) return null;

    return {
        status: getValueAtSaid(normalized.value, said),
        timestamp: normalized.ts ?? null,
    };
};

